import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const examples = [{
  image: 'https://i.postimg.cc/zvqBJBQb/1.jpg',
  alt: 'Ejemplo de ebook 1'
}, {
  image: 'https://i.postimg.cc/7YY6d57c/2.jpg',
  alt: 'Ejemplo de ebook 2'
}, {
  image: 'https://i.postimg.cc/JzSzsKFf/3.jpg',
  alt: 'Ejemplo de ebook 3'
}, {
  image: 'https://i.postimg.cc/Hx9YPmLH/4.jpg',
  alt: 'Ejemplo de ebook 4'
}, {
  image: 'https://i.postimg.cc/SRZykG8v/5.jpg',
  alt: 'Ejemplo de ebook 5'
}];
export function ExamplesCarousel() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);
  const next = useCallback(() => {
    setDirection(1);
    setCurrent(prev => (prev + 1) % examples.length);
  }, []);
  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent(prev => (prev - 1 + examples.length) % examples.length);
  }, []);
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 300 : -300,
      opacity: 0,
      scale: 0.9
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -300 : 300,
      opacity: 0,
      scale: 0.9
    })
  };
  return <section className="w-full py-24 px-6 bg-[#0a0f0d]" data-id="element-24">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0]" data-id="element-27">
            Ejemplos creados con EBOOK CREATOR
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-28">
            Ebooks reales generados usando el sistema paso a paso
          </p>
        </motion.div>

        <div className="relative" data-id="element-29">
          {/* Carousel */}
          <div className="relative w-full max-w-sm mx-auto overflow-hidden rounded-xl" style={{
          minHeight: '400px'
        }} data-id="element-30">
            <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-31">
              <motion.img key={current} src={examples[current].image} alt={examples[current].alt} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.4,
              ease: 'easeInOut'
            }} className="absolute inset-0 w-full h-full object-contain rounded-xl" data-id="element-32" />
            </AnimatePresence>
          </div>

          {/* Arrows */}
          <button onClick={prev} className="absolute left-0 md:-left-6 top-1/2 -translate-y-1/2 w-12 h-12 bg-[#050505]/80 border border-gray-700 rounded-full flex items-center justify-center text-white hover:bg-[#00d4aa]/20 hover:border-[#00d4aa]/50 transition-all" aria-label="Anterior" data-id="element-33">
            <ChevronLeft className="w-5 h-5" data-id="element-34" />
          </button>
          <button onClick={next} className="absolute right-0 md:-right-6 top-1/2 -translate-y-1/2 w-12 h-12 bg-[#050505]/80 border border-gray-700 rounded-full flex items-center justify-center text-white hover:bg-[#00d4aa]/20 hover:border-[#00d4aa]/50 transition-all" aria-label="Siguiente" data-id="element-35">
            <ChevronRight className="w-5 h-5" data-id="element-36" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3" data-id="element-37">
          {examples.map((_, i) => <button key={i} onClick={() => {
          setDirection(i > current ? 1 : -1);
          setCurrent(i);
        }} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${i === current ? 'bg-[#00d4aa] scale-125' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`Ejemplo ${i + 1}`} data-id="element-38" />)}
        </div>
      </div>
    </section>;
}